import React, {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {GoBackToSearchButton} from 'components/Accommodation/BackToSearchButton'
import {GridGalleryLoading} from 'components/Accommodation/GridGallery/GridGalleryLoading'
import {HotelDetailsLoading} from 'components/Accommodation/HotelDetails/HotelDetailsLoading'
import {LocationSummaryLoading} from 'components/Accommodation/LocationSummary/LocationSummaryLoading'
import {AccommodationOfferBox} from 'components/Accommodation/Offers/AccommodationOfferBox/AccommodationOfferBox'
import {CheckInCheckOutLoading} from 'components/Accommodation/Policies/CheckInCheckOut/CheckInCheckOutLoading'
import {PopularFacilitiesLoading} from 'components/Accommodation/PopularFacilities/PopularFacilitiesLoading'
import {ReviewSummaryLoading} from 'components/Accommodation/ReviewSummary/ReviewSummaryLoading'
import {PriceTrendDesktopLoading} from 'components/PriceTrend/PriceTrendDesktopLoading'
import {useOtaMode} from 'hooks/useOtaMode'

import {Box} from '@vio/atlas/helpers/Box'
import {PageWidthContainer} from '@vio/atlas/helpers/PageWidthContainer'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {Text} from '@vio/atlas/Text'
import {trackAccommodationPageFRP} from '@vio/core/src/_web/utils/analytics/trackPerformanceMetrics'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

import {AccommodationFixedHeader} from '../../AccommodationFixedHeader/AccommodationFixedHeader'
import {HotelTitleBlockLoading} from './HotelTitleBlockLoading'
import {
  DividerContainer,
  GridGalleryWrapper,
  HotelDetailsWrapper,
  LeftContentWrapper,
  MainContentWrapper,
  ReviewSummaryWrapper,
  RightContentWrapper,
  Wrapper
} from './styles'
import {TopOfferCtaDesktopLoading} from './TopOfferCtaDesktop'
import {useShouldShowHotelCardClickersContent} from './useShouldShowHotelCardClickersContent'

export const HotelAccommodationDesktopViewLoading = () => {
  const dispatch = useDispatch()
  const shouldShowHotelCardClickersContent =
    useShouldShowHotelCardClickersContent()
  const {isOTAMode} = useOtaMode()
  useEffect(() => {
    trackAccommodationPageFRP(dispatch)
  }, [dispatch])

  if (shouldShowHotelCardClickersContent) {
    return (
      <Wrapper>
        <PageWidthContainer paddingDesktopXsSize="s500">
          <Box marginBottom="s500">
            <GoBackToSearchButton />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
            gap="s500"
            marginBottom="s500"
          >
            <HotelTitleBlockLoading />
            <TopOfferCtaDesktopLoading showPrice={!isOTAMode} />
          </Box>
          <GridGalleryWrapper noBottomMargin>
            <GridGalleryLoading />
          </GridGalleryWrapper>
          <Box paddingBottom="s600">
            <AccommodationFixedHeader mode="inline" isVisible isLoading />
          </Box>
          {!isOTAMode && (
            <Box display="flex" flexDirection="column" gap="s500">
              <Text variant="titleL">
                <FormattedMessageWrapper
                  defaultMessage="Available deals"
                  id="availableDealsTopOffers"
                />
              </Text>
              <SkeletonLoader marginTop={0} />
            </Box>
          )}
        </PageWidthContainer>
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      <PageWidthContainer paddingDesktopXsSize="s500">
        <GoBackToSearchButton />
        <GridGalleryWrapper>
          <GridGalleryLoading />
        </GridGalleryWrapper>
        <MainContentWrapper>
          <LeftContentWrapper>
            <HotelDetailsWrapper>
              <HotelDetailsLoading />
            </HotelDetailsWrapper>
            <LocationSummaryLoading />
            <ReviewSummaryWrapper>
              <ReviewSummaryLoading />
            </ReviewSummaryWrapper>
            <DividerContainer />
            <PopularFacilitiesLoading />
            <DividerContainer />
            <CheckInCheckOutLoading layout="secondary" />
            <PriceTrendDesktopLoading />
          </LeftContentWrapper>
          <RightContentWrapper>
            <AccommodationOfferBox isLoading />
          </RightContentWrapper>
        </MainContentWrapper>
      </PageWidthContainer>
    </Wrapper>
  )
}
